import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'
import Topic from '../views/topic/index.vue'
import TopicInfo from '../views/topic/detail.vue'
import Source from '../views/source/index.vue'
import Search from '../views/search/index.vue'
import Entity from '../views/entity/index.vue'
import Relation from '../views/relation/index.vue'
import Audio from '../views/audio/index.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '吕正操研学中心',
      keepAlive: true
    }
  },
  {
    path: '/search',
    name: 'Source',
    component: Search,
    meta: {
      title: '搜索',
      keepAlive: true
    }
  },
  {
    path: '/source',
    name: 'Source',
    component: Source,
    meta: {
      title: '数字藏品'
    }
  },
  {

    path: '/entity',
    name: 'Entity',
    component: Entity,
    meta: {
      title: '实体'
    }
  },
  {
    path: '/relation',
    name: 'Relation',
    component: Relation,
    meta: {
      title: '关系图谱'
    }
  },
  {
    path: '/audio',
    name: 'Audio',
    component: Audio,
    meta: {
      title: '音频',
      keepAlive: true
    }
  },
  {
    path: '/topic',
    name: 'Topic',
    component: Topic,
    meta: {
      title: '专题'
    }
  },
  {
    path: '/topic/info',
    name: 'TopicInfo',
    component: TopicInfo,
    meta: {
      title: '专题'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
